//
export const PUBLIC_ROUTES = [
  '/login',
  '/login/email',
  '/login/wallet',
  '/invitation',
];

export const CHAINS = [
  {
    key: 'base',
    name: 'Base',
    symbol: 'ETH',
    chainId: 8453,
    order: 3,
    logo: '/image/chain/base.png',
    scanUrl: 'https://baseblockscan.com'
  },
  {
    key: 'bsc',
    name: 'BSC',
    symbol: 'BNB',
    chainId: 56,
    order: 4,
    logo: '/image/chain/bsc.png',
    scanUrl: 'https://bscscan.com'
  },
  {
    key: 'eth',
    name: 'ETH',
    symbol: 'ETH',
    order: 2,
    chainId: 1,
    logo: '/image/chain/eth.png',
    scanUrl: 'https://etherscan.io'
  },
  {
    key: 'sol',
    name: 'SOL',
    symbol: 'SOL',
    order: 1,
    chainId: 501,
    logo: '/image/chain/sol.png',
    scanUrl: 'https://solscan.io'
  },
];
